"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeGetSelectedTouristsFromExcludedServices = exports.getTotalPriceOfBookingServices = exports.getShouldRecalculatePrice = exports.getRecalculatedPriceEntity = exports.getRecalculatedPrice = exports.getRecalculatedOfferPrice = exports.getRecalculateOfferPriceUI = exports.getLastRecalculatedActiveServices = exports.getIsShow = exports.getFetchBookingServicesUI = exports.getActiveServices = exports.getActiveServiceByID = exports.getActiveBookingServices = void 0;
var _ramda = require("ramda");
var _reselect = require("reselect");
var _selectors = require("@otpusk/apisearch-toolbox/dist/services/selectors");
var _selectors2 = require("../../../../../../../bus/ui/selectors");
var _helpers = require("./helpers");
var _constants = require("./constants");
var domain = function domain(_) {
  return _.offerDetails.bookingServices;
};
var getIsShow = exports.getIsShow = (0, _ramda.pipe)(domain, (0, _ramda.prop)('isShow'));
var getFetchBookingServicesUI = exports.getFetchBookingServicesUI = (0, _ramda.partialRight)(_selectors2.getUI, [{
  key: _constants.FETCH_BOOKING_SERVICES_DATA
}]);
var getRecalculateOfferPriceUI = exports.getRecalculateOfferPriceUI = (0, _ramda.partialRight)(_selectors2.getUI, [{
  key: _constants.RECALCULCATE_OFFER_PRICE
}]);
var getActiveServices = exports.getActiveServices = (0, _ramda.pipe)(domain, (0, _ramda.prop)('activeServices'));
var getActiveCountOfService = (0, _ramda.pipe)(_ramda.keys, _ramda.length);
var getSelectedTourist = (0, _ramda.pipe)(_ramda.keys, (0, _ramda.map)(Number));
var EMPTY_VALUE = {};
var getActiveServiceByID = exports.getActiveServiceByID = (0, _ramda.converge)(function (activeServices, serviceID) {
  return activeServices[serviceID] || EMPTY_VALUE;
}, [getActiveServices, function (_, _ref) {
  var serviceID = _ref.serviceID;
  return serviceID;
}]);
var getActiveBookingServices = exports.getActiveBookingServices = function getActiveBookingServices(state, _ref2) {
  var currency = _ref2.currency,
    offerID = _ref2.offerID;
  var activeBookingServices = getActiveServices(state);
  var bookingServicesByOffer = (0, _selectors.getBookingServicesByOffer)(state, {
    currency: currency,
    offerID: offerID
  });
  return (0, _ramda.map)(function (service) {
    return (0, _ramda.mergeAll)([service, {
      activeCountOfService: getActiveCountOfService(activeBookingServices[service.id]),
      selectedTourists: getSelectedTourist(activeBookingServices[service.id])
    }]);
  }, (0, _ramda.filter)(function (service) {
    return (0, _ramda.keys)(activeBookingServices[service.id]).length;
  }, bookingServicesByOffer));
};
var getTotalPriceOfBookingServices = exports.getTotalPriceOfBookingServices = (0, _reselect.createSelector)(getActiveBookingServices, function (_, _ref3) {
  var currency = _ref3.currency;
  return currency;
}, function (services, currency) {
  return (0, _ramda.reduce)(function (total, service) {
    var activeCountOfService = service.activeCountOfService,
      isGlobalService = service.isGlobalService;
    var price = service.price[currency];
    if (price) {
      return (0, _helpers.getCountOfService)(activeCountOfService, isGlobalService) * price + total;
    }
    return total;
  }, 0, services);
});
var makeGetSelectedTouristsFromExcludedServices = exports.makeGetSelectedTouristsFromExcludedServices = function makeGetSelectedTouristsFromExcludedServices() {
  return (0, _reselect.createSelector)(getActiveServices, function (_, _ref4) {
    var excludedServices = _ref4.excludedServices;
    return excludedServices;
  }, function (services, excludedServices) {
    return (0, _ramda.pipe)((0, _ramda.props)(excludedServices), (0, _ramda.filter)(Boolean), (0, _ramda.map)(_ramda.keys), _ramda.flatten, (0, _ramda.map)(Number), _ramda.uniq)(services);
  });
};
var getRecalculatedPriceEntity = exports.getRecalculatedPriceEntity = (0, _ramda.pipe)(domain, (0, _ramda.prop)('recalculatedPrice'));
var getLastRecalculatedActiveServices = exports.getLastRecalculatedActiveServices = (0, _ramda.pipe)(domain, (0, _ramda.prop)('lastRecalculatedActiveServices'));
var getRecalculatedPrice = exports.getRecalculatedPrice = (0, _ramda.pipe)(getRecalculatedPriceEntity, (0, _ramda.prop)('price'));
var getRecalculatedOfferPrice = exports.getRecalculatedOfferPrice = (0, _ramda.converge)(function (price, currency) {
  return price === null || price === void 0 ? void 0 : price[currency];
}, [getRecalculatedPrice, function (_, _ref5) {
  var currency = _ref5.currency;
  return currency;
}]);
var getShouldRecalculatePrice = exports.getShouldRecalculatePrice = (0, _ramda.pipe)(domain, (0, _ramda.prop)('shouldRecalculatePrice'));